//点击日历日期
export const ALARM_CHOOSETYPE_CLICK_DATE='ALARM/CHOOSETYPE/CLICK_DATE';

export const ALARM_ISOPEN='ALARM/CHOOSETYPE/ISOPEN';